export default "__VITE_ASSET__nhz3ppzK__"